interface BlogMastheadProps {
  tagline?: string;
}

/** Slim intro banner for the home/about pages — the primary nav bar (Header) already carries the "Hustlance Blog" identity and the link back to hustlance.com, so this only needs the tagline. */
export function BlogMasthead({ tagline = 'Stories, insights, and opportunities for students building their future.' }: BlogMastheadProps) {
  return (
    <div className="border-b border-gray-100 bg-hustlance-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 text-center">
        <p className="text-gray-500 max-w-xl mx-auto text-lg">{tagline}</p>
      </div>
    </div>
  );
}
